import React, { CSSProperties } from 'react';
import './DividerBlock.css';

interface DividerConfig {
  orientation?: 'horizontal' | 'vertical';
  color?: string;
  thickness?: number;
  margin?: string;
  style?: CSSProperties;
}

interface DividerBlockProps {
  block: {
    divider?: DividerConfig;
    orientation?: 'horizontal' | 'vertical';
    color?: string;
    thickness?: number;
    margin?: string;
    style?: CSSProperties;
  };
}

const DividerBlock: React.FC<DividerBlockProps> = ({ block }) => {
  // Handle nested divider structure - prioritize values inside the divider object
  let config: DividerConfig = {};

  if (block.divider) {
    // Use values from inside the divider object
    config = {
      orientation:
        block.divider.orientation || block.orientation || 'horizontal',
      color: block.divider.color || block.color || '#e5e7eb',
      thickness: block.divider.thickness || block.thickness || 1,
      margin: block.divider.margin || block.margin || '16px 0',
      style: block.divider.style || block.style,
    };
  } else {
    // Fallback to flat structure
    config = {
      orientation: block.orientation || 'horizontal',
      color: block.color || '#e5e7eb',
      thickness: block.thickness || 1,
      margin: block.margin || '16px 0',
      style: block.style,
    };
  }

  const dividerStyles: CSSProperties = {
    border: 'none',
    margin: config.margin,
    ...config.style,
  };

  if (config.orientation === 'horizontal') {
    dividerStyles.height = `${config.thickness}px`;
    dividerStyles.backgroundColor = config.color;
    dividerStyles.width = '100%';
  } else if (config.orientation === 'vertical') {
    dividerStyles.width = `${config.thickness}px`;
    dividerStyles.backgroundColor = config.color;
    dividerStyles.height = '100%';
    dividerStyles.margin = '0 16px';
  }

  return (
    <hr
      className={`divider-block divider-${config.orientation}`}
      style={dividerStyles}
    />
  );
};

export default DividerBlock;
